import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type {
  CategoryName,
  CategoryObjectType,
  MetadataCategoriesAppState,
  MetadataCategoryViewsAppState,
  MetadataMetadataCategorySchemaPatched,
} from './types';

export const initialMetadataCategoryViews: MetadataCategoryViewsAppState = {
  assets: {},
  collections: {},
  custom_actions: {},
  search: {},
  segments: {},
};

const initialState: MetadataCategoriesAppState = {
  metadataCategoryViews: initialMetadataCategoryViews,
  metadataTypeCategories: {},
};

export const metadataCategoriesSlice = createSlice({
  name: 'admin_metadata_categories',
  initialState,
  reducers: {
    setMetadataCategory: (
      state,
      action: PayloadAction<{
        category: MetadataMetadataCategorySchemaPatched;
        name: CategoryName;
        objectType: CategoryObjectType;
      }>,
    ) => {
      const { objectType, name, category } = action.payload;
      state.metadataCategoryViews[objectType][name] = category;
    },
    setMetadataCategoriesOfType: (
      state,
      action: PayloadAction<{
        objectType: CategoryObjectType;
        categories: MetadataMetadataCategorySchemaPatched[];
      }>,
    ) => {
      state.metadataTypeCategories[action.payload.objectType] =
        action.payload.categories;
    },
  },
});

export const { setMetadataCategory, setMetadataCategoriesOfType } =
  metadataCategoriesSlice.actions;

export const metadataCategoriesReducer = metadataCategoriesSlice.reducer;
